import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useReportAccidentQuery } from "./hooks/useReportAccidentQuery";
import { useReportAccidentCommand } from "./hooks/useReportAccidentCommand";
import { ROUTES } from "../../core/routes/routes";
import { DateUtil } from "../../common/utils/date.util";
import Table from "../../common/components/Table";
import Pagination from "../../common/components/Pagination";
import IconButton from "../../common/components/IconButton";
import Textfield from "../../common/components/Textfiled";
import { BsFileSpreadsheet, BsClipboardPlus, BsPencilSquare, BsTrash } from "react-icons/bs";

function ListAccidents() {
  const navigate = useNavigate();
  const [filters, setFilters] = useState({
    search: "",
    startDate: "",
    endDate: "",
  });
  const [appliedFilters, setAppliedFilters] = useState({
    search: "",
    startDate: "",
    endDate: "",
  });

  const { reportAccidents, totalPages, loading, onChangePage, currentPage, refresh } =
    useReportAccidentQuery(appliedFilters);
  const { exportExcel, deleteReportAccident } = useReportAccidentCommand(refresh);

  const handleFilter = () => {
    setAppliedFilters({ ...filters });
  };

  const columnas = [
    { header: "Nombre", accessor: "namePersonInvolved" },
    { header: "Documento", accessor: "documentPersonInvolved" },
    { header: "Tipo de Contrato", accessor: "typeContract" },
    { header: "Lugar", accessor: "placeOfEvent" },
    { header: "Placa", accessor: "vehiclePlate" },
    {
      header: "Fecha del Siniestro",
      accessor: "dateAccident",
      render: (val) => DateUtil.format(val),
    },
    {
      header: "Lecciones Aprendidas",
      accessor: "disseminationLesson",
      render: (val, row) =>
        val ? (
          <Link to={`${ROUTES.LIST_DISSEMINATION_LESSON}?accidentId=${row.id}`}>
            Ver lección aprendida
          </Link>
        ) : (
          <span style={{ color: "#999" }}>Sin lección</span>
        ),
    },
    {
      header: "Investigación",
      accessor: "investigationId",
      render: (val) =>
        val ? (
          <Link to={`${ROUTES.LIST_INVESTIGATION}?investigationId=${val}`}>
            Ver investigación
          </Link>
        ) : (
          <span style={{ color: "#999" }}>Sin investigación</span>
        ),
    },
    {
      header: "Acciones",
      accessor: "actions",
      render: (_, row) => (
        <div className="d-flex align-items-center gap-2">
          <IconButton
            tooltipText="Editar"
            onClick={() =>
              navigate(ROUTES.REGISTER_ACCIDENTS, { state: { editData: row } })
            }
          >
            <BsPencilSquare size={20} />
          </IconButton>
          <IconButton
            tooltipText="Eliminar"
            className="text-danger"
            onClick={() => deleteReportAccident(row.id)}
          >
            <BsTrash size={20} />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Lista de siniestros</h1>
        <div className="d-flex gap-2">
          <IconButton
            tooltipText="Registrar"
            onClick={() => navigate(ROUTES.REGISTER_ACCIDENTS)}
          >
            <BsClipboardPlus size={24} />
          </IconButton>
          <IconButton
            tooltipText="Exportar"
            onClick={() => exportExcel(appliedFilters)}
          >
            <BsFileSpreadsheet size={24} />
          </IconButton>
        </div>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3 flex-wrap flex-md-nowrap align-items-end">
          <div className="w-100">
            <Textfield
              label="Buscar"
              name="search"
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, search: value }))
              }
              placeholder="Buscar..."
              value={filters.search}
            />
          </div>

          <div className="d-flex gap-3 justify-content-center flex-wrap flex-md-nowrap align-items-end">
            <Textfield
              label="Fecha inicio"
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, startDate: value }))
              }
            />
            <Textfield
              label="Fecha fin"
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, endDate: value }))
              }
            />
            <div className="mb-3">
              <label className="form-label d-block">&nbsp;</label>
              <button
                type="button"
                className="btn btn-dark"
                style={{ height: 38, whiteSpace: "nowrap" }}
                onClick={handleFilter}
              >
                Filtrar
              </button>
            </div>
          </div>
        </div>

        <Table
          columns={columnas}
          data={reportAccidents}
          showIndex={true}
          loading={loading}
        />

        <Pagination
          onChangePage={onChangePage}
          page={currentPage}
          totalPages={totalPages}
        />
      </section>
    </main>
  );
}

export default ListAccidents;
